import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Детски чаршафи с ластик от ранфорс – 100% памук | GoToBed',
  description:
    'Детски чаршафи с ластик от ранфорс, 100% памук. Размери 60/120, 70/140, 82/190, 90/200. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Детски чаршафи с ластик от ранфорс
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Детски чаршафи с ластик ранфорс – 100% памук за бебешко и детско легло
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Детските чаршафи с ластик от ранфорс са практично и удобно решение за бебешки и детски
          легла. Изработени от 100% памук, те са меки, дишащи и подходящи за чувствителната детска
          кожа. Благодарение на ластика по целия ръб чаршафът прилепва плътно към матрака и остава
          стабилен по време на сън.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще откриете детски чаршафи с ластик ранфорс в разнообразие от едноцветни
          и шарени десени, изработени по поръчка за различни размери матраци като 60/120, 70/140,
          82/190 и 90/200. Ранфорсът е плътен и издръжлив памучен плат, който осигурява комфорт и
          устойчивост при ежедневна употреба.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyDetskiCharshafiSLastikRanfors />;
}

function SeoBodyDetskiCharshafiSLastikRanfors() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Детски чаршафи с ластик от ранфорс за бебешко и детско легло */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Детски чаршафи с ластик от ранфорс за бебешко и детско легло
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Детските чаршафи с ластик от ранфорс са практично и удобно решение за бебешки и детски
        легла. Благодарение на ластика по целия ръб чаршафът прилепва плътно към матрака и остава
        стабилно фиксиран по време на сън.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В тази категория ще откриете детски чаршафи с ластик от ранфорс, изработени от 100% памук.
        Ранфорсът е плътен, лек и издръжлив памучен плат, който осигурява комфорт и добра дишаемост.
        Това го прави много подходящ за бебешко и детско спално бельо.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Всички чаршафи се изработват внимателно в България от висококачествени памучни материи със
        сертификат OEKO-TEX Standard 100, което гарантира безопасност и липса на вредни вещества в
        текстила.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        За да създадете пълен комплект от същата материя, можете да комбинирате чаршафа с
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-plikove/2/10/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски пликове ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-kalufki/2/8/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски калъфки ранфорс
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Голям избор от размери детски чаршафи с ластик ранфорс */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Голям избор от размери детски чаршафи с ластик ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Едно от основните предимства на нашите продукти е голямото разнообразие от размери, което
          позволява лесно да намерите подходящ детски чаршаф с ластик ранфорс за различни матраци.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме детски чаршафи с ластик ранфорс със следните размери:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '60/110/20',
            '60/120/20',
            '60/130/20',
            '60/140/20',
            '65/110/20',
            '65/120/20',
            '65/130/20',
            '65/140/20',
            '65/150/20',
            '65/160/20',
            '70/110/20',
            '70/120/20',
            '70/130/20',
            '70/140/20',
            '70/150/20',
            '70/160/20',
            '70/170/20',
            '70/180/20',
            '70/190/20',
            '75/140/20',
            '75/150/20',
            '75/160/20',
            '75/170/20',
            '75/180/20',
            '75/190/20',
            '82/180/20',
            '82/190/20',
            '82/200/20',
            '82/200/30',
            '90/190/20',
            '90/190/30',
            '90/200/20',
            '90/200/30'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Този широк избор позволява лесно да намерите подходящ чаршаф с ластик за бебешко легло или
          детски матрак.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако търсите и други варианти за детско спално бельо, можете да разгледате и
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-charshafi/2/7/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            детски чаршафи ранфорс
          </Typography>
        </Box>

        {/* H2: Какво представлява платът ранфорс? */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какво представлява платът ранфорс?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ранфорсът е плътна памучна тъкан, изработена от 100% естествени влакна. Той е много
          популярен за спално бельо, защото съчетава комфорт, здравина и дълготрайност.
        </Typography>
        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Предимства на ранфорса
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '&#10004; 100% памук',
            '&#10004; дишащ и приятен на допир плат',
            '&#10004; устойчивост при пране',
            '&#10004; комфорт през всички сезони',
            '&#10004; подходящ за детско спално бельо'
          ].map((item) => (
            <Typography
              key={item}
              variant="body1"
              sx={{ color: 'text.secondary' }}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Детските чаршафи от ранфорс са практичен избор за родители, които търсят здрав и удобен
          памучен чаршаф за детско легло.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако предпочитате по-фина и гладка материя, можете да разгледате и
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-charshafi-s-lastik/2/9/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            детски чаршафи с ластик памучен сатен
          </Typography>
        </Box>

        {/* H2: Перфектно прилягане към матрака */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Перфектно прилягане към матрака
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ластикът е поставен по целия ръб на чаршафа, което позволява той да обхване плътно матрака
          и да остане стабилен по време на сън. Това предотвратява набръчкване на плата и осигурява
          комфортна повърхност за спане.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Чаршафите са подходящи за матраци с височина до 20 см и до 30 см, което позволява добро
          прилягане към различни бебешки и детски матраци.
        </Typography>

        {/* H2: Свиваемост на памучния плат */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Свиваемост на памучния плат
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Нашите чаршафи са изработени от 100% памук, което означава, че е възможна естествена
          свиваемост около 4–5% след първите пранета.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          При изработката на чаршафите предварително предвиждаме необходимото количество плат, за да
          се компенсира тази естествена свиваемост. Затова при поръчка не е необходимо да добавяте
          допълнителни сантиметри – просто изберете размер според реалните размери на матрака.
        </Typography>

        {/* H2: Популярни размери детски чаршафи с ластик ранфорс */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери детски чаршафи с ластик ранфорс
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          {[
            'чаршаф с ластик 60/120/20 (60х120х20) см',
            'чаршаф с ластик 70/140/20 (70х140х20) см',
            'чаршаф с ластик 70/160/20 (70х160х20) см',
            'чаршаф с ластик 90/200/30 (90х200х30) см'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички детски чаршафи с ластик се изработват индивидуално след направена поръчка, според
          избрания размер на матрака.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          за около 4–7 работни дни.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за детски чаршафи с ластик ранфорс
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер детски чаршаф с ластик?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            За да изберете подходящ чаршаф с ластик за детско легло, измерете ширината, дължината и
            височината на матрака. След това изберете чаршаф със същите размери.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящ ли е ранфорсът за бебешко спално бельо?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Ранфорсът е 100% памучен плат, който е дишащ, здрав и приятен на допир. Това го
            прави много подходящ за бебешко и детско спално бельо.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свиват ли се детските чаршафи от ранфорс след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички изделия от естествен памук, и чаршафите от ранфорс могат да имат естествена
            свиваемост около 4–5% след първите пранета.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са чаршафите за бебешко легло?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Благодарение на богатия избор от размери можете лесно да намерите подходящ чаршаф с
            ластик за бебешко или детско легло.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват чаршафите?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички чаршафи се изработват в България, специално за всяка поръчка и според избрания
            размер.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
